import { Box } from '@mui/material';
import { Button, Heading, Text } from '../atomic';
import GreenCornerBox from '../ui/GreenCornerBox';

/**
 * Call to action section for the collaborate page
 *
 * @returns {JSX.Element} Collaborate CTA section component
 */
function CollaborateCallToAction() {
  return (
    <GreenCornerBox
      sx={{
        textAlign: 'center',
        py: 6,
        boxShadow: 1,
        maxWidth: 'none', // Override default maxWidth
      }}
    >
      <Heading
        variant="h2"
        sx={{ mb: 3, fontSize: '1.75rem', fontWeight: 600 }}
      >
        Start Your Transformation Journey
      </Heading>
      <Text sx={{ mb: 4, fontSize: '1.125rem', maxWidth: '600px', mx: 'auto' }}>
        Whatever your role in healthcare, we're ready to collaborate and create
        innovative solutions that improve patient care and operational
        excellence.
      </Text>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Button
          variant="contained"
          size="large"
          onClick={() =>
            window.open(
              'https://www.linkedin.com/company/rsm-collective/',
              '_blank',
              'noopener,noreferrer'
            )
          }
          aria-label="Contact RSM Collective on LinkedIn (opens in new window)"
          sx={{
            backgroundColor: 'primary.main',
            color: 'var(--color-primary-text)',
            px: 4,
            py: 1.5,
            fontSize: '1.1rem',
            borderRadius: 0,
            position: 'relative',
            border: '2px solid var(--color-primary)',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: -2,
              left: -2,
              width: '12px',
              height: '12px',
              borderTop: '2px solid var(--color-primary)',
              borderLeft: '2px solid var(--color-primary)',
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              bottom: -2,
              right: -2,
              width: '12px',
              height: '12px',
              borderBottom: '2px solid var(--color-primary)',
              borderRight: '2px solid var(--color-primary)',
            },
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          Let's Collaborate
        </Button>
      </Box>
    </GreenCornerBox>
  );
}

export default CollaborateCallToAction;
